import React, { useState, useRef, useEffect } from 'react'
import Modal from 'react-modal'
import LayoutTransporter from '../../Components/LayoutTransporter/LayoutTransporter'
import {
	FormSectionCard,
	GradientText,
	SubmitButton,
	SubmitButtonContainer,
} from '../PasserCommande/PasserCommande.styles'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router'
import { CustomInput } from '../RegisterTransporter/style'
import { CreateUser } from '../../api/auth'
import { useSelector } from 'react-redux'

import 'flatpickr/dist/themes/material_blue.css'
import Flatpickr from 'react-flatpickr'
import { French } from 'flatpickr/dist/l10n/fr.js'
import { Controller } from 'react-hook-form'
import moment from 'moment'
import toast from 'react-hot-toast'
import PhoneInput from 'react-phone-input-2';
import { validatePhoneNumber } from '../../utils/phoneValidator'
import { useTranslation } from 'react-i18next'

Modal.setAppElement('#root')

function CreateChauffeur(props) {
	const { register, handleSubmit, watch, control, formState: { errors }, getValues, setValue } = useForm()

	const history = useHistory()
	const [modalIsOpen, setModalIsOpen] = useState(false)
	const [loading, setLoading] = useState(false)
	const currentUser = useSelector((state) => state.auth.user)
	const flatpickrRef = useRef(null);
	const isManualInput = useRef(false);
    const{t} = useTranslation();
	const onSubmit = async (data) => {
		delete data._password

		data.date_embauche = moment(data.date_embauche).toISOString()
		data.date_naiss = moment(data.date_naiss).toISOString()
		setLoading(true)
		try {
			await CreateUser({
				...data,
				role: 'chauffeur',
				transporter: currentUser._id,
			})

			setModalIsOpen(true)
		} catch (error) {
			const data = error?.response?.data?.errors
			if (data?.msg === 'EMAIL_ALREADY_EXISTS') {
				toast.error(
					t("email_already_exists"),
					{
						style: {
							fontFamily: 'Montserrat',
						},
					}
				)
			} else {
				toast.error(t("transfer_request_err"), {
					style: {
						fontFamily: 'Montserrat',
					},
				});
			}
		} finally {
			setLoading(false)
		}
	}
	const handleInputChange = (e, onChange) => {
		const value = e.target.value;
		// Allow only numbers and slashes
		if (/^[0-9/]*$/.test(value) && value.length <= 10) {
			onChange(value);
		}
	};
   
	const renderLicense = (license) =>{
		switch(license) {
			case "Léger" : return t("light") ;
			case "Lourds" : return t("heavy") ;
			case "Super lourds" : return t("extra_heavy") ;
			default : return ""
		}
	}

	const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 768);


	useEffect(() => {
		const checkIfMobile = () => {
			setSmallScreen(window.innerWidth < 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);

	return (
		<LayoutTransporter>
			<div
				style={{
					//height: '80vh',
					width: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					paddingTop: '2rem',
					paddingBottom: '4rem',
					paddingLeft: '1.5rem',
					paddingRight: '1.5rem',
				}}
			>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<div
						onClick={() => {
							history.goBack()
						}}
						style={{
							background: '#51C7F2',
							width: isSmallScreen ? '1.5rem' : '2.5rem',
							height: isSmallScreen ? '1.5rem' : '2.5rem',
							borderRadius: '100%',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							cursor: 'pointer',
						}}
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width={14.017}
							height={14.11}
							viewBox='0 0 14.017 14.11'
						>
							<g
								data-name='Group 11287'
								fill='none'
								stroke='#fff'
								strokeWidth={2}
							>
								<path
									data-name='Path 11687'
									d='M16.6 11.818l-6.348 6.349 2.115 2.115 4.232 4.232'
									transform='translate(-8.838 -11.113)'
								/>
								<path
									data-name='Path 11688'
									d='M22.147 11.818l-6.348 6.349 6.348 6.348'
									transform='translate(-8.838 -11.113)'
								/>
							</g>
						</svg>
					</div>

					<div
						style={{
							width: '1rem',
						}}
					/>

					<GradientText marginTop={'unset'} style={{
						fontSize: isSmallScreen ? '1.5rem' : '2.5rem'
					}}>
						{`${t("add")} ${t("driver")}`.toUpperCase()}
					</GradientText>
				</div>
				<div
					style={{
						width: '100%',
						fontFamily: 'Montserrat',
					}}
				>
					<form onSubmit={handleSubmit(onSubmit)}>
						<FormSectionCard>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									marginBottom: '2rem',
								}}
							>
								<span
									style={{
										color: '#262626',
										marginBottom: '1rem',
									}}
								>
									{t("gender")}<span style={{ color: 'red' }}>*</span>
								</span>
								<div
									style={{
										display: 'flex',
										flexDirection: isSmallScreen ? 'column' : 'row',
										gap: isSmallScreen ? '1rem' : 0
									}}
								>
									<div
										style={{
											width: isSmallScreen ? '100%' : '30%',
										}}
									>
										<input
											type='radio'
											style={{
												marginRight: '1rem',
												transform: 'scale(1.5)',
											}}
											{...register('sexe', {
												required: true,
											})}
											value={'homme'}
										/>

										<span>{t("male")}</span>
									</div>

									<div>
										<input
											type='radio'
											style={{
												marginRight: '1rem',
												transform: 'scale(1.5)',
											}}
											{...register('sexe', {
												required: true,
											})}
											value={'femme'}
										/>

										<span>{t("female")}</span>
									</div>


								</div>
								{errors.sexe && (
									<div style={{ color: 'red', marginTop: '0.5rem', fontSize: "14px" }}>
										{t("select_gender")}
									</div>
								)}
							</div>

							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									marginBottom: '2rem',
								}}
							>
								<span
									style={{
										color: '#262626',
										marginBottom: '1rem',
									}}
								>
									{t("license")}<span style={{ color: 'red' }}>*</span>
								</span>
								<div
									style={{
										display: 'flex',
										flexDirection: isSmallScreen ? 'column' : 'row',
										gap: isSmallScreen ? '1rem' : 0
									}}
								>
									{['Léger', 'Lourds', 'Super lourds'].map(
										(item, index) => (
											<div
												key={String(index)}
												style={{
													width: isSmallScreen ? '100%' : '25%',
													display: 'flex',
													flexDirection: 'row',
												}}
											>
												<div>
													<input
														type='checkbox'
														style={{
															marginRight: isSmallScreen ? '0.5rem' : '1rem',
															transform: 'scale(1.5)',
														}}
														{...register('permis', {
															required: true,
														})}
														value={item}
													/>
												</div>

												<span>{renderLicense(item)}</span>
											</div>
										)
									)}
								</div>
								{errors.permis && (
									<div style={{ color: 'red', marginTop: '0.5rem', fontSize: "14px" }}>
										{t("select_license_type")}
									</div>
								)}
							</div>


							<div
								style={{
									display: 'flex',
									flexDirection: isSmallScreen ? 'column' : 'row',
									marginBottom: '2rem',
									gap: isSmallScreen ? '1rem' : 0
								}}
							>
								<div
									style={{
										width: isSmallScreen ? '100%' : '50%',
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										{t("last_name")} <span style={{ color: 'red' }}>*</span>
									</span>
									<CustomInput
										type='text'
										placeholder=''
										{...register('last_name', {
											required: t("nom_destinataire_err"),
											minLength: {
												value: 3,
												message: t("article_m") +t("last_name") +t("err_message2"),
											},
											pattern: {
												value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s'\-]+$/,
												message: t("article_m") +t("last_name") +t("err_message3"),
											},
										})}
									/>
									{errors.last_name && (
										<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
											{errors.last_name.message}
										</div>
									)}
								</div>

								<div style={{ width: 50 }} />

								<div
									style={{
										width: isSmallScreen ? '100%' : '50%',
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										{t("first_name" )} <span style={{ color: 'red' }}>*</span>
									</span>
									<CustomInput
										type='text'
										placeholder=''
										{...register('first_name', {
											required: t("prenom_destinataire_err"),
											minLength: {
												value: 3,
												message: t("article_m") +t("first_name") +t("err_message2"),
											},
											pattern: {
												value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s'\-]+$/,
												message: t("article_m") +t("first_name") +t("err_message3"),
											},
										})}
									/>
									{errors.first_name && (
										<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
											{errors.first_name.message}
										</div>
									)}
								</div>
							</div>

							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									marginBottom: '2rem',
								}}
							>
								<div
									style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										{t("address")} <span style={{ color: 'red' }}>*</span>
									</span>
									<CustomInput
										type='text'
										placeholder=''
										{...register('address', {
											required: t("enter_address"),
											minLength: {
												value: 3,
												message: t("article_elided") +t("address") +t("err_message2"),
											},
											pattern: {
												value: /^[A-Za-zÀ-ÿ0-9\s',.\-/()°]+$/,
												message:t("article_elided") +t("address") +t("err_message3"),
											},
										})}
									/>
									{errors.address && (
										<div style={{ color: 'red', marginTop: '0.5rem', fontSize: "14px" }}>
											{errors.address.message}
										</div>
									)}
								</div>
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									paddingBottom: '2rem',
								}}
							>
								<span
									style={{
										color: '#262626',
										paddingBottom: '1rem',
									}}
								>
									{t("city")} <span style={{ color: 'red' }}>*</span>
								</span>
								<CustomInput
									type='text'
									{...register('city', {
										required: t("enter_city"),
										minLength: {
											value: 3,
											message: t("article_f") +t("city") +t("err_message2"),
										},
										pattern: {
											value: /^.+$/,
											message: t("article_f") +t("city") +t("err_message3"),
										},
									})}
								/>
								{errors.city && (
									<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
										{errors.city.message}
									</div>
								)}
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									paddingBottom: '2rem',
								}}
							>
								<span
									style={{
										color: '#262626',
										paddingBottom: '1rem',
									}}
								>
									{t("zip_code")} <span style={{ color: 'red' }}>*</span>
								</span>
								<CustomInput
									type='text'
									{...register('postalCode', {
										required: t("enter_postal_code"),
										pattern: {
											value: /^\d{5}$/,
											message: t("zip_code_err_message"),
										},
									})}
								/>
								{errors.postalCode && (
									<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
										{errors.postalCode.message}
									</div>
								)}
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: isSmallScreen ? 'column' : 'row',
									marginBottom: '2rem',
								}}
							>
								<div
									style={{
										width: isSmallScreen ? '100%' : '50%',
										display: 'flex',
										flexDirection: 'column',
										paddingBottom: '2rem',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										{t("contact_us_formulair_item2")} <span style={{ color: 'red' }}>*</span>
									</span>

									<Controller
										name="phone"
										control={control}
										rules={{
											required: t("phone_number_err1"),
											validate: validatePhoneNumber
										}}
										render={({ field }) => (
											<PhoneInput
												country={'fr'}
												value={field.value}
												onChange={(value, data) => {
													field.onChange(value);
												}}
												inputStyle={{
													paddingRight: '1.5rem',
													paddingTop: '1.5rem',
													paddingBottom: '1.5rem',
													borderRadius: '0.5rem',
													border: 'none',
													fontFamily: 'Montserrat',
													color: '#858ea8',
													flex: '1',
													display: 'flex',
													width: '100%',
												}}
												buttonStyle={{
													borderRadius: '0.5rem',
													border: 'none',
													fontFamily: 'Montserrat',
													color: '#858ea8',
													flex: '1',
													display: 'flex',
												}}
											/>
										)}
									/>
									{errors.phone && (
										<div
											style={{
												color: 'red',
												marginTop: '0.5rem',
												fontSize: '14px',
											}}
										>
											{errors.phone.message}
										</div>
									)}
								</div>

								<div style={{ width: 50 }} />

								<div
									style={{
										width: isSmallScreen ? '100%' : '50%',
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										{t("email")} <span style={{ color: 'red' }}>*</span>
									</span>
									<CustomInput
										type='text'
										placeholder=''
										{...register('email', {
											required: t("email_destinataire_err"),
											pattern: {
												value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
												message: t("email_err_message"),
											},
										})}
									/>
									{errors.email && (
										<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
											{errors.email.message}
										</div>
									)}
								</div>
							</div>

							<div
								style={{
									display: 'flex',
									flexDirection: isSmallScreen ? 'column' : 'row',
									marginBottom: '2rem',
									gap: isSmallScreen ? '1rem' : 0
								}}
							>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										width: isSmallScreen ? '100%' : '50%',
									}}
								>
									<span
										style={{
											marginBottom: '1rem',
											color: 'black',
											fontSize: 14,
										}}
									>
										{t("date_of_birth")} <span style={{ color: 'red' }}>*</span>
									</span>
									<Controller
										name='date_naiss'
										rules={{
											required: t("enter_birth_date"),
											validate: value => {
												const today = new Date();
												const birthDate = new Date(value);
												const age = today.getFullYear() - birthDate.getFullYear();
												birthDate.setFullYear(today.getFullYear());

												if (
													age < 18 ||
													(age === 18 &&
														today.getTime() < birthDate.getTime())
												) {
													return t("birth_date_err");
												}

												return true;
											},

										}}
										control={control}
										render={({
											field: { onChange, value },
										}) => (
											<Flatpickr
												onChange={([date]) => {
													onChange(date);
												}}
												onBlur={(e) => {
													const parsed = moment(e.target.value, 'DD/MM/YYYY', true);
													if (parsed.isValid()) {
														onChange(parsed.toDate());
													}
												}}
												className='date-input'

												options={{
													mode: 'single',
													locale: French,
													dateFormat: 'd/m/Y',
													allowInput: true,
													placeholder: 'JJ/MM/AAAA',
													ariaDateFormat: 'j F Y',
													formatDate: (date) => {
														return moment(date).format('DD/MM/YYYY');
													},
													parseDate: (datestr) => {
														return moment(datestr, 'DD/MM/YYYY').toDate();
													}
												}}
												value={value}
												placeholder="JJ/MM/AAAA"
											/>
										)}
									/>
									{errors.date_naiss && (
										<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
											{errors.date_naiss.message}
										</div>
									)}
								</div>

								<div style={{ width: 50 }} />

								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										width: isSmallScreen ? '100%' : '50%',
									}}
								>
									<span
										style={{
											marginBottom: '1rem',
											color: 'black',
											fontSize: 14,
										}}
									>
										{t("hire_date")} <span style={{ color: 'red' }}>*</span>
									</span>

									<Controller
										name='date_embauche'
										rules={{
											required: t("enter_hire_date"),
											validate: {
												notFuture: value => {
													const today = moment().startOf('day');
													const selectedDate = moment(value).startOf('day');
													if (selectedDate.isAfter(today)) {
														return t("hire_date_err");
													}
													return true;
												},
												// Nouvelle validation ajoutée
												afterBirth: value => {
													const birthDate = getValues('date_naiss');
													if (!birthDate) return true;

													const embaucheDate = moment(value);
													const birth = moment(birthDate);

													// Calcul de la différence en années
													const yearsDiff = embaucheDate.diff(birth, 'years');

													// Vérifier que la date d'embauche est au moins 18 ans après la naissance
													if (yearsDiff < 18) {
														return t("hire_date_err2");
													}

													return true;
												}
											}



										}}
										control={control}
										render={({
											field: { onChange, value },
										}) => (
											<Flatpickr
												onChange={([date]) => {
													onChange(date)
												}}
												onBlur={(e) => {
													const parsed = moment(e.target.value, 'DD/MM/YYYY', true);
													if (parsed.isValid()) {
														onChange(parsed.toDate());
													}
												}}
												className='date-input'
												options={{
													mode: 'single',
													locale: French,
													dateFormat: 'd/m/Y',
													allowInput: true,
													placeholder: 'JJ/MM/AAAA',
													ariaDateFormat: 'j F Y',
													formatDate: (date) => {
														return moment(date).format('DD/MM/YYYY');
													},
													parseDate: (datestr) => {
														return moment(datestr, 'DD/MM/YYYY').toDate();
													}
												}}
												value={value}
												placeholder="JJ/MM/AAAA"

											/>
										)}
									/>
									{errors.date_embauche && (
										<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
											{errors.date_embauche.message}
										</div>
									)}
								</div>
							</div>

							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									marginBottom: '2rem',
								}}
							>
								<span
									style={{
										color: '#262626',
										marginBottom: '1rem',
									}}
								>
									Fimo <span style={{ color: 'red' }}>*</span>
								</span>
								<div
									style={{
										display: 'flex',
										flexDirection: isSmallScreen ? 'column' : 'row',
										gap: isSmallScreen ? '1rem' : 0
									}}
								>
									{[
										{ label: t("yes"), value: true },
										{ label: t("no"), value: false },
									].map(({ label, value }, index) => (
										<div
											key={String(index)}
											style={{
												width: isSmallScreen ? '100%' : '20%',
											}}
										>
											<input
												type="radio"
												style={{
													marginRight: '1rem',
													transform: 'scale(1.5)',
												}}
												{...register('fimo', { required: true })}
												value={value}
											/>

											<span>{label}</span>
										</div>
									))}
								</div>
								{errors.fimo && (
									<div style={{ color: 'red', marginTop: '0.5rem' }}>
										{t("select_fimo_option")}
									</div>
								)}
							</div>

							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									marginBottom: '2rem',
								}}
							>
								<span
									style={{
										color: '#262626',
										marginBottom: '1rem',
									}}
								>
									{t("hazardous_materials")} <span style={{ color: 'red' }}>*</span>
								</span>
								<div
									style={{
										display: 'flex',
										flexDirection: isSmallScreen ? 'column' : 'row',
										gap: isSmallScreen ? '1rem' : 0
									}}
								>
									{[
										{ label: t("yes"), value: true },
										{ label: t("no"), value: false },
									].map(({ label, value }, index) => (
										<div
											key={String(index)}
											style={{
												width: isSmallScreen ? '100%' : '20%',
											}}
										>
											<input
												type="radio"
												style={{
													marginRight: '1rem',
													transform: 'scale(1.5)',
												}}
												{...register('danger', { required: true })}

												value={value}
											/>

											<span>{label}</span>
										</div>
									))}
								</div>
								{errors.danger && (
									<div style={{ color: 'red', marginTop: '0.5rem' }}>
										{t("select_hazardous_option")}
									</div>
								)}
							</div>

							<div
								style={{
									display: 'flex',
									flexDirection: isSmallScreen ? 'column' : 'row',
									gap: isSmallScreen ? '1rem' : 0
								}}
							>
								<div
									style={{
										width: isSmallScreen ? '100%' : '50%',
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										{t("mdp")} <span style={{ color: 'red' }}>*</span>
									</span>
									<CustomInput
										type='password'
										placeholder=''
										{...register('password', {
											required: t("enter_password"),
											minLength: {
												value: 8,
												message: t("mdp_err_message"),
											},
										})}
									/>
									{errors.password && (
										<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
											{errors.password.message}
										</div>
									)}
								</div>

								<div style={{ width: 50 }} />

								<div
									style={{
										width: isSmallScreen ? '100%' : '50%',
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										{t("confirm_mdp")} <span style={{ color: 'red' }}>*</span>
									</span>
									<CustomInput
										type='password'
										placeholder=''
										{...register('_password', {
											required: t("enter_password"),
											validate: (value) =>
												value === watch('password') || t("passwords_do_not_match"),
										})}
									/>
									{errors._password && (
										<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
											{errors._password.message}
										</div>
									)}
								</div>
							</div>
						</FormSectionCard>

						<div style={{ height: '1rem' }} />

						<SubmitButtonContainer>
							<SubmitButton type='submit' disabled={loading}>

								{loading ? (
									<div className='loader'></div>
								) : ( 
									t("save")
								)}
							</SubmitButton>
						</SubmitButtonContainer>
					</form>
				</div>
			</div>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => { }}
				style={{
					overlay: {
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(0, 0, 0, 0.45)',
					},
					content: {
						top: '50%',
						left: '50%',
						right: 'auto',
						bottom: 'auto',
						marginRight: '-50%',
						transform: 'translate(-50%, -50%)',
						borderRadius: 19,
						width : isSmallScreen ? '90%' : '60%'
					},
				}}
				contentLabel='Example Modal'
			>
				<div
					style={{
						
						fontFamily: 'Montserrat',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						fontSize: 15,
						textAlign: 'center',
					}}
				>
					<GradientText style={{
						fontSize: isSmallScreen ? '1.5rem' : '2.5rem'
					}}>{t("model_title").toUpperCase()}</GradientText>

					<div
						style={{
							marginTop: 20,
						}}
					>
						{t("add_driver_model_msg1")} 😃
						<br />
						{t("add_driver_model_msg2")}
						<br />
						{t("add_driver_model_msg3")}
					</div>

					<button
						onClick={() => {
							history.push(`/chauffeurs`)
						}}
						style={{
							padding: '0.5rem 1rem',
							background: '#50F5A9',
							border: 'none',
							cursor: 'pointer',
							color: 'white',
							borderRadius: 7,
							marginTop: 30,
						}}
					>
						OK
					</button>
				</div>
			</Modal>
		</LayoutTransporter>

	)
}

export default CreateChauffeur
